export class AllowanceInfo {
    constructor(
        public currentAllowance: number,
        public currentAllowanceWei: string | number,
        public amountChecked: number,
        public isSufficient: boolean,
    ) {}
}
